import axios from 'axios'

class HelpSectionService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Alan Aguilar
  * @description Handle event to get the information of help section of hibou.legal
  * @date 09-09-2021
  * @param {String} token
  * @returns {Object}
  * @memberof HelpSectionService
  */
  async getHelpSectionDigitalSignApp(token) {
    let response = await axios.get(`${this.apiUrl}/help-section`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }
}

export { HelpSectionService as default }
